const moment = require("moment-timezone");

const formattedDate = (data, user) => {
  return moment(data)
    .tz(user.preferences.timeZone)
    .format("L, LTS z");
};

export const formattedDateWithDefault = data => {
  return moment(data)
    .tz("America/Chicago")
    .format("L, LTS z");
};

export const formattedTimeStamp = (data, user) => {
  return moment(new Date(Number(data)))
    .tz(user.preferences.timeZone)
    .format("L, LTS z");
};

export const formattedTimeStampWithDefault = data => {
  return moment(new Date(Number(data)))
    .tz("America/Chicago")
    .format("L, LTS z");
};

export default formattedDate;
